import { SessionReplacedBanner } from '../components/SessionReplacedBanner';
import { PublicHeader, publicHeaderTopPaddingClass } from '../components/PublicHeader';
import { PublicFooter } from '../components/PublicFooter';
import { StoreDownloadButtons } from '../components/StoreDownloadButtons';
import { LandingWorkflowCards } from '../components/LandingWorkflowCards';
import { LandingFeaturesSection } from '../components/LandingFeaturesSection';
import { LandingHowItWorksSection } from '../components/LandingHowItWorksSection';
import { LandingTestimonialsSection } from '../components/LandingTestimonialsSection';

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />

      <div className={`max-w-6xl mx-auto w-full px-4 sm:px-6 ${publicHeaderTopPaddingClass} pb-2`}>
        <SessionReplacedBanner />
      </div>

      <section className="pt-8 pb-16 sm:pb-20 px-4 sm:px-6 text-center overflow-x-visible">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-6xl font-black text-slate-900 tracking-tight mb-6 leading-tight">
            Procurement
            <br />
            <span className="text-blue-600">Redefined.</span>
          </h1>
          <p className="text-slate-500 text-lg sm:text-xl font-medium max-w-2xl mx-auto mb-10 leading-relaxed">
            The world&apos;s most advanced real-time reverse auction platform. Streamlines your supply chain with highest
            Cost &amp; Time saving.
          </p>
          <div id="download" className="scroll-mt-24">
            <StoreDownloadButtons />
          </div>
        </div>
        <LandingWorkflowCards />
      </section>

      <LandingFeaturesSection />

      <LandingHowItWorksSection />

      <LandingTestimonialsSection />

      <PublicFooter />
    </div>
  );
}
